import 'css-chunksrc/client/pages/milestonePage/details/nameForm/styles.scss';export default {
  "input": "_input_vx43e_1"
};